import { FC, useMemo, useState } from "react";
import { HOCType } from "../../constants/types";
import { createContext } from "../../helpers/createContext";

interface IRightPopupContext {
  search?: string;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  showOnlyRenewing: boolean;
  setShowOnlyRenewing: React.Dispatch<React.SetStateAction<boolean>>;
}

const [RightPopupContext, useRightPopupContext] = createContext<IRightPopupContext>();

const RightPopupProvider: FC = (props) => {
  const [search, setSearch] = useState("");
  const [showOnlyRenewing, setShowOnlyRenewing] = useState(false);

  const value = useMemo(
    () => ({
      search,
      setSearch,
      showOnlyRenewing,
      setShowOnlyRenewing,
    }),
    [search, showOnlyRenewing]
  );

  return <RightPopupContext.Provider value={value}>{props.children}</RightPopupContext.Provider>;
};

const withRightPopupProvider: HOCType = (WrappedComponent) => (props) => (
  <RightPopupProvider>
    <WrappedComponent {...props} />
  </RightPopupProvider>
);

export { RightPopupContext, useRightPopupContext, RightPopupProvider, withRightPopupProvider };
